import { Button } from "@/components/atoms/Button";
import { FormHeaderProps } from "./FormHeader.types";
import { PlusIcon, ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { FormStatusEnum } from "../FormWrapper/FormWrapper.types";
import { RefreshCwIcon } from "lucide-react";

export const FormHeader = <T,>({
  title,
  subtitle,
  formStatus = FormStatusEnum.List,
  canAdd = false,
  changeFormStatus,
  selectItem,
  refetch,
}: FormHeaderProps<T>) => {

  const ChangeStatus = (): void => {
    if (formStatus === FormStatusEnum.List) {
      changeFormStatus && changeFormStatus(FormStatusEnum.Add);
    } else {
      changeFormStatus && changeFormStatus(FormStatusEnum.List);
      selectItem && selectItem(undefined);
    }
  };

  return (
    <div className="flex justify-between items-center mb-4 pb-4 border-b rounded space-x-4">
      <div>
        <h2 className="text-xl font-bold">{title}</h2>
        <small>{subtitle}</small>
      </div>
      <div className="flex space-x-2">
        {formStatus === FormStatusEnum.List && (
          <Button size="xs" onClick={refetch} variant="secondary">
            <RefreshCwIcon className="h-6 w-6" aria-hidden="true" />
          </Button>
        )}
        {changeFormStatus &&
          ((formStatus === FormStatusEnum.List && canAdd) || formStatus !== FormStatusEnum.List) && (
            <Button
              size="xs"
              onClick={ChangeStatus}
              variant={formStatus === FormStatusEnum.List ? "primary" : "secondary"}
            >
              {formStatus === FormStatusEnum.List ? (
                <PlusIcon className="h-6 w-6" aria-hidden="true" />
              ) : (
                <ArrowUturnLeftIcon className="h-6 w-6" aria-hidden="true" />
              )}
            </Button>
          )}
      </div>
    </div>
  );
};
